import React, { Component } from 'react'
import './VoenKom.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import QRCode from 'qrcode.react';
import dayjs from 'dayjs'

export default class Voencom extends Component {
    constructor(props) {
        super(props)
        var date = dayjs(new Date()).format('DD.MM.YYYY')
        this.state = {
            currentDate: date,
        }
    }

    OpenReportsPage(reportsPage, reportType) {
        this.props.OpenReportsPage(reportsPage, reportType)
    }
    selectLanguage(language) {
        this.props.selectLanguage(language)
    }

    render() {
        const { VoenKom } = this.props
        if (VoenKom && !VoenKom.length) return null
        else
            return (
                <div className='ObhodnoiList D_main_header' >
                    <header>
                        <i className="fas fa-arrow-left" onClick={() => this.OpenReportsPage(0, 0)}></i>
                        <ReactToPrint content={() => this.componentRef}>
                            <PrintContextConsumer>
                                {({ handlePrint }) => (
                                    <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                                )}

                            </PrintContextConsumer>
                        </ReactToPrint>
                        {this.props.language === 1 ? <h2>Военком</h2> : <h2>Военком</h2>}
                        <div className='Language'>
                            <h4 onClick={() => this.selectLanguage(0)} className={this.props.language === 0 ? 'Lang_Active' : 'Lang'}>Рус/Кырг</h4>
                            <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                            <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                        </div>
                    </header>
                    {/* Русский вариант */}
                    {this.props.language === 1 ?
                        <div className="A4 Voencom" ref={el => (this.componentRef = el)}>
                            <span style={{ marginRight: '10px', float: 'right', fontStyle: 'italic', fontFamily: 'Calibri', fontSize: '11px' }}>Форма №26</span>
                            <table>
                                <thead>
                                    <tr>
                                        <td className='Voencom_title'>{VoenKom[0].length ? VoenKom[0][0].v2 : '_________'}</td>
                                        <td className='Voencom_title'>Справка</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='Voencom_title' style={{ textAlign: 'center' }}>
                                            {this.state.currentDate}
                                            <br /> {VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz}
                                            <br />{VoenKom[0].length && VoenKom[0][0].adres + ', ' + 'т. 0(312)-' + VoenKom[0].length && VoenKom[0][0].tel}</td>
                                        <td>
                                            {`Выдана призывнику ${VoenKom[1].length ? VoenKom[1][0].BirthDate.split('.')[2] : '______'}г. рождения в том, что в ${VoenKom[2].length ? VoenKom[2][0].come_date : '______'} году `}
                                            <h3>{VoenKom[1].length ? VoenKom[1][0].s_fio : ''}</h3>
                                            {`${VoenKom[2].length ? VoenKom[2][0].c_name2 : '_________'} в ${VoenKom[0].length ? VoenKom[0][0].v2_kuda : '_________'}, ${VoenKom[0].length && VoenKom[0][0].faculty?.length ? VoenKom[0][0].faculty : ''}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' style={{ textAlign: 'start' }}>
                                            {`приказом  № ${VoenKom[2].length ? VoenKom[2][0].come_reg : '_________'} от ${VoenKom[2].length ? VoenKom[2][0].come_date : '_________'} г. (${VoenKom[1].length ? VoenKom[1][0].name.toLowerCase() : '_________'})`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' style={{ textAlign: 'start' }}>
                                            {`в настоящее время обучается на ${VoenKom[1].length ? VoenKom[1][0].id_rate : '_________'} курсе, группы ${VoenKom[1].length ? VoenKom[1][0].p20 : '_________'}, очного отделения.`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' style={{ textAlign: 'start' }}>
                                            {`Лицензия образовательной организации  ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz} ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].date_licen : VoenKom[0][0].license_spuz_date}.`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' style={{ textAlign: 'start' }}>
                                            {`Срок окончания  учебного заведения: ${this.props.endYear > 0 ? this.props.endYear : (VoenKom[2].length && VoenKom[2][0].end_year)} год.`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' style={{ textAlign: 'start' }}>
                                            {`Справка выдана для  предъявления в ${VoenKom[3].length ? VoenKom[3][0].raion : '_________'} районный (городской) военный комиссариат.`}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            {VoenKom[4].length && VoenKom[4][0].insert_pole ?
                                <div className='podpisi'>
                                    <div>
                                        {VoenKom[4].length && VoenKom[4][0].insert_pole}
                                    </div>
                                    <div>
                                        <p></p>
                                        <span>(подпись)</span>
                                    </div>
                                </div> : null}
                            {VoenKom[5].length && VoenKom[5][0].insert_pole ?
                                <div className='podpisi'>
                                    <div>
                                        {VoenKom[5].length && VoenKom[5][0].insert_pole}
                                    </div>
                                    <div>
                                        <p></p>
                                        <span>(подпись)</span>
                                    </div>
                                </div> : null}
                            {VoenKom[5].length && VoenKom[6][0].insert_pole ?
                                <div className='podpisi'>
                                    <div>
                                        {VoenKom[6][0].insert_pole}
                                    </div>
                                    <div>
                                        <p></p>
                                        <span>(подпись)</span>
                                    </div>
                                </div> : null}
                            <QRCode
                                id="qrCodeEl"
                                value={`${this.state.currentDate}:${this.props.id_a_year}${this.props.id_rate}${this.props.id_group}${this.props.id_student}`} />




                            {/* Кыргызский вариант */}
                        </div> : this.props.language === 2 ?
                            <div className="A4 Voencom" ref={el => (this.componentRef = el)}>
                                <span style={{ marginRight: '10px', float: 'right', fontStyle: 'italic', fontFamily: 'Calibri', fontSize: '11px' }}>Форма №26</span>
                                <table>
                                    <thead>
                                        <tr>
                                            <td className='Voencom_title'>{VoenKom[0].length ? VoenKom[0][0].v2_k : '_________'}</td>
                                            <td className='Voencom_title'>Маалымкат</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>

                                            <td className='Voencom_title' style={{ textAlign: 'center' }}>
                                                {this.state.currentDate}
                                                <br /> {VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz}
                                                <br />{(VoenKom[0].length ? VoenKom[0][0].adres : '_________') + ', ' + 'т. 0(312)-' + (VoenKom[0].length ? VoenKom[0][0].tel : '_________')}</td>
                                            <td>
                                                <>{`${VoenKom[1].length ? VoenKom[1][0].BirthDate.split('.')[2] : '______'}-жылы туулган  чакырылуучуга берилген, себеби ${VoenKom[2][0].come_date ? VoenKom[2][0].come_date : '_____'}-жылы `}</>
                                                <h3>{VoenKom[1].length ? VoenKom[1][0].s_fio : ''}</h3>
                                                <>{VoenKom[0].length ? VoenKom[0][0].v2_k_kimdin : '_________'} {VoenKom[0].length && VoenKom[0][0].faculty_k.length ? VoenKom[0][0].faculty_k : ''}</>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ textAlign: 'start' }}>
                                                <>{`${VoenKom[2].length ? VoenKom[2][0].come_date : '_________'}-жылдын   № ${VoenKom[2].length ? VoenKom[2][0].come_reg : '_________'}-буйругу менен ${VoenKom[2].length ? VoenKom[2][0].come_kg : '_________'} (${VoenKom[1].length ? VoenKom[1][0].name.toLowerCase() : '_________'})`}</>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ textAlign: 'start' }}>
                                                <> {`жана азыркы убакта   ${VoenKom[1].length ? VoenKom[1][0].id_rate : '_________'}-курста, ${VoenKom[1].length ? VoenKom[1][0].p20 : '_________'} тайпасында,  күндүзгү бѳлүмүндѳ  окуп жатат.`}</>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ textAlign: 'start' }}>
                                                {`Билим берүү мекемесинин лицензиясы ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz} ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].date_licen : VoenKom[0][0].license_spuz_date}.`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ textAlign: 'start' }}>
                                                {`Окуу жайын${this.props.endYear > 0 ? this.props.endYear : (VoenKom[2].length && VoenKom[2][0].end_year)}-жылы аяктайт.`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ textAlign: 'start' }}>
                                                <>{`Маалымкат ${VoenKom[3].length ? VoenKom[3][0].raion_kg : '_________'} райондук (шаардык) аскер комиссариатына кѳрсѳтүү үчүн берилген.`}</>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {VoenKom[4].length && VoenKom[4][0].insert_pole_kg ?
                                    <div className='podpisi'>
                                        <div>
                                            <>{VoenKom[4].length && VoenKom[4][0].insert_pole_kg}</>
                                        </div>
                                        <div>
                                            <p><br /></p>
                                            <span>(колу)</span>
                                        </div>
                                    </div> : null}
                                {VoenKom[5].length && VoenKom[5][0].insert_pole_kg ?
                                    <div className='podpisi'>
                                        <div>
                                            <>{VoenKom[5].length && VoenKom[5][0].insert_pole_kg}</>
                                        </div>
                                        <div>
                                            <p> <br /></p>
                                            <span>(колу)</span>
                                        </div>
                                    </div> : null}
                                {VoenKom[5].length && VoenKom[6][0].insert_pole_kg ?
                                    <div className='podpisi'>
                                        <div>
                                            {VoenKom[6][0].insert_pole_kg}
                                        </div>
                                        <div>
                                            <p></p>
                                            <span>(колу)</span>
                                        </div>
                                    </div> : null}
                                <QRCode
                                    id="qrCodeEl"
                                    value={`${this.state.currentDate}:${this.props.id_a_year}${this.props.id_rate}${this.props.id_group}${this.props.id_student}`} />




                                {/* Кыргызско-Русский вариант */}
                            </div> :
                            <div className="A4 Voencom" ref={el => (this.componentRef = el)}>
                                <span style={{ marginRight: '10px', float: 'right', fontStyle: 'italic', fontFamily: 'Calibri', fontSize: '11px' }}>Форма №26</span>
                                <table>
                                    <thead>
                                        <tr>
                                            <td className='Voencom_title'>{VoenKom[0].length ? VoenKom[0][0].v2 : '_________'}</td>
                                            <td className='Voencom_title'>Маалымкат/Справка</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='Voencom_title' style={{ textAlign: 'center' }}>
                                                {this.state.currentDate}
                                                <br /> {VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz}
                                                <br />{VoenKom[0][0].adres + ', ' + 'т. 0(312)-' + VoenKom[0][0].tel}</td>
                                            <td>
                                                <p>{`${VoenKom[1].length ? VoenKom[1][0].BirthDate.split('.')[2] : '____'}-жылы туулган  чакырылуучуга берилген, себеби ${VoenKom[2].length ? VoenKom[2][0].come_date : '_____'}-жылы `}</p>
                                                {`Выдана призывнику ${VoenKom[1].length ? VoenKom[1][0].BirthDate.split('.')[2] : '_________'}г. рождения в том, что в ${VoenKom[2].length ? VoenKom[2][0].come_date : '_________'} году `}
                                                <h3>{VoenKom[1].length ? VoenKom[1][0].s_fio : '_________'}</h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ textAlign: 'start' }}>
                                                <p>{VoenKom[0].length ? VoenKom[0][0].v2_k_kimdin : '_________'} {VoenKom[0].length && VoenKom[0][0].faculty_k?.length ? VoenKom[0][0].faculty_k : ''}</p>
                                                {`${VoenKom[2].length ? VoenKom[2][0].c_name2 : '_________'} в ${VoenKom[0].length ? VoenKom[0][0].v2_kuda : '_________'}, ${VoenKom[0].length && VoenKom[0][0].faculty?.length ? VoenKom[0][0].faculty : ''}`}
                                                <p>{`${VoenKom[2].length ? VoenKom[2][0].come_date : '_________'}-жылдын  № ${VoenKom[2].length ? VoenKom[2][0].come_reg : '_________'}-буйругу менен ${VoenKom[2].length ? VoenKom[2][0].come_kg : '_________'} (${VoenKom[1].length ? VoenKom[1][0].name.toLowerCase() : '_________'})`}</p>
                                                {`приказом  № ${VoenKom[2].length ? VoenKom[2][0].come_reg : '_________'} от ${VoenKom[2].length ? VoenKom[2][0].come_date : '_________'} г. (${VoenKom[1].length ? VoenKom[1][0].name.toLowerCase() : '_________'})`}
                                                <p> {`жана азыркы убакта   ${VoenKom[1].length ? VoenKom[1][0].id_rate : '_________'}-курста, ${VoenKom[1].length ? VoenKom[1][0].p20 : '_________'} тайпасында,  күндүзгү бѳлүмүндѳ  окуп жатат.`}</p>
                                                {`в настоящее время обучается на ${VoenKom[1].length ? VoenKom[1][0].id_rate : '_________'} курсе, группы ${VoenKom[1].length ? VoenKom[1][0].p20 : '_________'}, очного отделения.`}
                                                <p>{`Билим берүү мекемесинин лицензиясы ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz} ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].date_licen : VoenKom[0][0].license_spuz_date}.`}</p>
                                                {`Лицензия образовательной организации  ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].nomer_licen : VoenKom[0][0].license_spuz} ${VoenKom[0].length && VoenKom[0][0].k_f == 0 ? VoenKom[0][0].date_licen : VoenKom[0][0].license_spuz_date}.`}
                                                <p>{`Окуу жайын ${this.props.endYear > 0 ? this.props.endYear : (VoenKom[2].length && VoenKom[2][0].end_year)}-жылы аяктайт.`}</p>
                                                {`Срок окончания  учебного заведения: ${this.props.endYear > 0 ? this.props.endYear : (VoenKom[2].length && VoenKom[2][0].end_year)} год.`}
                                                <p>{`Маалымкат ${VoenKom[3].length ? VoenKom[3][0].raion_kg : '_________'} райондук (шаардык) аскер комиссариатына кѳрсѳтүү үчүн берилген.`}</p>
                                                {`Справка выдана для  предъявления в ${VoenKom[3].length ? VoenKom[3][0].raion : '_________'} районный (городской) военный комиссариат.`}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {(VoenKom[4].length && VoenKom[4][0].insert_pole_kg) || (VoenKom[4].length && VoenKom[4][0].insert_pole) ?
                                    <div className='podpisi'>
                                        <div>
                                            <p>{VoenKom[4].length ? VoenKom[4][0].insert_pole_kg : '_________'}</p>
                                            {VoenKom[4].length ? VoenKom[4][0].insert_pole : '_________'}
                                        </div>
                                        <div>
                                            <p></p>
                                            <span>(колу/подпись)</span>
                                        </div>
                                    </div> : null}
                                {(VoenKom[5].length && VoenKom[5][0].insert_pole_kg) || (VoenKom[5].length && VoenKom[5][0].insert_pole) ?
                                    <div className='podpisi'>
                                        <div>
                                            <p>{VoenKom[5].length ? VoenKom[5][0].insert_pole_kg : '_________'}</p>
                                            {VoenKom[5].length ? VoenKom[5][0].insert_pole : '_________'}
                                        </div>
                                        <div>
                                            <p></p>
                                            <span>(колу/подпись)</span>
                                        </div>
                                    </div> : null}
                                {(VoenKom[6].length && VoenKom[6][0].insert_pole_kg) || (VoenKom[6].length && VoenKom[6][0].insert_pole) ?
                                    <div className='podpisi'>
                                        <div>
                                            <p>{VoenKom[6][0].insert_pole_kg}</p>
                                            {VoenKom[6][0].insert_pole}
                                        </div>
                                        <div>
                                            <p></p>
                                            <span>(колу/подпись)</span>
                                        </div>
                                    </div> : null}
                                <QRCode
                                    id="qrCodeEl"
                                    value={`${this.state.currentDate}:${this.props.id_a_year}${this.props.id_rate}${this.props.id_group}${this.props.id_student}`} />
                            </div>
                    }

                </div>
            )
    }
}


